export default "__VITE_ASSET__78c746f1__"